module.exports = __webpack_public_path__ + "static/img/bcg3.cf75a876.webp";